import VeryBadSmily from "../assets/smiley-rating-very-bad.svg"
import PoorSmily from "../assets/smiley-rating-poor.svg"
import MediumSmily from "../assets/smiley-rating-medium.svg"
import GoodSmily from "../assets/smiley-rating-good.svg"
import ExcellentSmily from "../assets/smiley-rating-excellent.svg"
import { createEnumChecker } from "../../../../../lib/enums"
import { SmilyValueTypes } from "../../../../merchant/admin/survey/surveyTypes"

const isSmileyValue = createEnumChecker(SmilyValueTypes)

export const displaySmileyWithoutText = (smileyLabel: string) => {
    const rawValue = smileyLabel.toUpperCase()
    const value = isSmileyValue(rawValue) ? rawValue : undefined

    switch (value) {
        case SmilyValueTypes.BAD:
            return VeryBadSmily
        case SmilyValueTypes.POOR:
            return PoorSmily
        case SmilyValueTypes.MEDIUM:
            return MediumSmily
        case SmilyValueTypes.GOOD:
            return GoodSmily
        case SmilyValueTypes.EXCELLENT:
            return ExcellentSmily
        default:
            return ""
    }
}
